import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {SuggestionListsService} from '../../../../services/suggestion-lists.service';
import {Router} from '@angular/router';
import { AdminService } from '../../../../../../../services/admin.service';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

const HTTP_OK = 200;
const EXPIRED_ROUTE_PART = 'ex-suggestion-expired';
const EX_NOTIFICATIONS_ROUTE = '/ex-notifications';
const MODAL_DISMISS_REASON = 'Cross click';
const CANCELLATION_ERROR = 'C_H_S';
const EMPTY_TEXT = '';

@Component({
  selector: 'app-cancel-popup',
  templateUrl: './cancel-popup.component.html',
  styleUrls: ['./cancel-popup.component.css']
})
export class CancelPopupComponent implements OnInit, OnDestroy {
  slList = null;
  notifyID: string;
  disableBtn = false;
  showErrorMsg = false;
  responseResultText = EMPTY_TEXT;
  private destroy$ = new Subject<void>();

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    public suggestionListsService: SuggestionListsService,
    private adminService: AdminService
  ) { }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setSL(sl, notifyID) {
    this.slList = sl;
    this.notifyID = notifyID;
  }

  markNotify(itemId) {
    const sendingParams = {
      id: itemId,
      notificationCategory: "SUGGESTION"
    };
    this.adminService.notifyIsView(sendingParams).subscribe(
      (response: any) => {},
      () => {
      }
    );
  }

  submit() {
    if (this.disableBtn) {
      return;
    }
    this.disableBtn = true;
    this.showErrorMsg = false;
    this.suggestionListsService.cancelPostponementSL(this.slList.id)
      .takeUntil(this.destroy$)
      .subscribe(
        response => this.handleSuccess(response),
        () => this.handleError()
      );
  }

  private handleSuccess(response: HttpResponse<Object>): void {
    if (response.status !== HTTP_OK) {
      this.handleError();
      return;
    }
    this.disableBtn = false;
    if (this.router.url.includes(EXPIRED_ROUTE_PART)) {
      this.markNotify(this.notifyID);
      this.router.navigate([EX_NOTIFICATIONS_ROUTE]);
      this.activeModal.dismiss(MODAL_DISMISS_REASON);
      return;
    }
    this.activeModal.close(true);
  }

  private handleError(): void {
    this.disableBtn = false;
    this.showErrorMsg = true;
    this.responseResultText = CANCELLATION_ERROR;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/suggestion-lists/components/view-suggestion-list/popups/cancel-popup/cancel-popup.component.ts